import { useRole } from "./hooks/useRole";

// The same things are named differently for the two audiences. IntraScene
// staff work in the system's own terms; customers see plain words for what
// they bought and where it is installed.
export type Words = {
  store: string;
  Store: string;
  stores: string;
  Stores: string;
  allStores: string;
  recorder: string;
  Recorder: string;
  recorders: string;
  Recorders: string;
  box: string;
  Box: string;
  boxes: string;
  Boxes: string;
  group: string;
  Group: string;
  groups: string;
  Groups: string;
};

const STAFF: Words = {
  store: "store",
  Store: "Store",
  stores: "stores",
  Stores: "Stores",
  allStores: "All stores",
  recorder: "recorder",
  Recorder: "Recorder",
  recorders: "recorders",
  Recorders: "Recorders",
  box: "connector",
  Box: "Connector",
  boxes: "connectors",
  Boxes: "Connectors",
  group: "camera profile",
  Group: "Camera profile",
  groups: "camera profiles",
  Groups: "Camera profiles",
};

const CUSTOMER: Words = {
  store: "location",
  Store: "Location",
  stores: "locations",
  Stores: "Locations",
  allStores: "All locations",
  recorder: "video recorder",
  Recorder: "Video recorder",
  recorders: "video recorders",
  Recorders: "Video recorders",
  box: "IntraScene box",
  Box: "IntraScene box",
  boxes: "IntraScene boxes",
  Boxes: "IntraScene boxes",
  group: "camera group",
  Group: "Camera group",
  groups: "camera groups",
  Groups: "Camera groups",
};

export function useWords(): Words {
  return useRole().isStaff ? STAFF : CUSTOMER;
}

/** `1 location`, `3 locations`. */
export function count(n: number, one: string, many: string): string {
  return `${n} ${n === 1 ? one : many}`;
}
